import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from './routes/Home';
import Login from './routes/login/Login';
import Logout from './routes/login/Logout';
import Layout from './routes/Layout/Layout';

import './css/app.css'
import './css/table.css'
import './css/card.css'
import Expire from "./routes/static/Expire";
import AppProvider from "./hooks/AppProvider";
import Users from "./routes/admin/Users";
import PrivateRoute from "./routes/PrivateRoute";
import Students from "./routes/admin/Students";
import Student from "./routes/app/Student";
import Role from "./routes/app/Role";
import GameAssign from "./routes/app/game/GameAssign";
import Games from "./routes/admin/Games";
import GameView from "./routes/app/game/GameView";
import GameMyView from "./routes/app/game/GameMyView";
import NotFound from "./routes/static/NotFound";
import RoleAnimation from "./routes/static/RoleAnimation";
import GameDetails from "./routes/admin/games/GameDetails";
import BehaviorGroups from "./routes/app/behavior/BehaviorGroups";
import BehaviorGroupDetails from "./routes/app/behavior/BehaviorGroupDetails";
import BehaviorPoints from "./routes/app/behavior/BehaviorPoints";
import { BehaviorSessionAnimation, BehaviorCurrentTermAnimation, BehaviorTermAnimation } from "./routes/static/BehaviorSessionAnimation";
import BehaviorTermStudentsAnimation from "./routes/static/BehaviorTermStudentsAnimation";

function App() {
    return (
        <BrowserRouter>
            <AppProvider>
                <Routes>
                    <Route path='/' element={<Layout />}>
                        <Route path='/' element={<PrivateRoute level={0}/>}>
                            <Route index element={<Home />} />
                            <Route path='logout' element={<Logout />} />
                        </Route>
                        
                        <Route path='login' element={<Login />} />

                        <Route path="app/" element={<PrivateRoute level={5} />}>
                            <Route path="student" element={<Student />} />
                            <Route path="role" element={<Role />} />
                            <Route path="game/" >
                                <Route path="assign" element={<GameAssign />} />
                                <Route path="view" element={<GameView />} />
                                <Route path="myview" element={<GameMyView />} />
                            </Route>
                            <Route path="behavior/" >
                                <Route path="groups" element={<BehaviorGroups />} />
                                <Route path="groups/:groupId" element={<BehaviorGroupDetails />} />
                                <Route path="points" element={<BehaviorPoints />} />
                            </Route>
                        </Route>

                        <Route path='admin/' element={<PrivateRoute level={10} />}>
                            <Route path='users' element={<Users />} />
                            <Route path='students' element={<Students />} />
                            <Route path='games' element={<Games />} />
                            <Route path='games/:gameId' element={<GameDetails />} />
                        </Route>
                    </Route>
                    <Route path="/role-animation" element={<PrivateRoute level={5} />}>
                        <Route path="" element={<RoleAnimation />} />
                    </Route>
                    <Route path="/behavior-session-animation" element={<PrivateRoute level={5} />}>
                        <Route path="" element={<BehaviorSessionAnimation />} />
                    </Route>
                    <Route path="/behavior-current-term-animation" element={<PrivateRoute level={5} />}>
                        <Route path="" element={<BehaviorCurrentTermAnimation />} />
                    </Route>
                    <Route path="/behavior-term-animation/:termId/" element={<PrivateRoute level={5} />}>
                        <Route path="groups" element={<BehaviorTermAnimation />} />
                        <Route path="students" element={<BehaviorTermStudentsAnimation />} />
                    </Route>
                    <Route path='/expire' element={<Expire />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </AppProvider>
      </BrowserRouter>
    )
}

export default App;